import type { DeliveryStatus, TicketStatus } from "@/api/support";

/**
 * The user we build this for has red-green color blindness, so status
 * indicators across /admin/support intentionally avoid red/green pairings
 * (unlike Monica's default StatusBadge red/green theme) and use
 * blue/orange/purple instead, combined with distinct icons and text labels
 * so meaning never depends on color alone.
 */
export const TICKET_STATUS_OPTIONS: TicketStatus[] = ["open", "waiting", "resolved"];

export const ticketStatusDisplay: Record<TicketStatus, { label: string; dotClassName: string; textClassName: string }> =
  {
    open: { label: "Open", dotClassName: "bg-colorBlue", textClassName: "text-colorBlue" },
    waiting: { label: "Waiting", dotClassName: "bg-colorOrange", textClassName: "text-colorOrange" },
    resolved: { label: "Resolved", dotClassName: "bg-purple-500", textClassName: "text-purple-600" },
  };

export const deliveryStatusDisplay: Record<
  DeliveryStatus,
  { label: string; icon: string; textClassName: string; bgClassName: string }
> = {
  not_applicable: { label: "N/A", icon: "i-bp-info", textClassName: "text-textMuted", bgClassName: "bg-borderLight" },
  pending: {
    label: "Pending",
    icon: "i-bp-pending",
    textClassName: "text-colorOrange",
    bgClassName: "bg-colorOrangeLight",
  },
  sending: {
    label: "Sending",
    icon: "i-bp-spinner animate-spin",
    textClassName: "text-colorBlue",
    bgClassName: "bg-colorBlueLight",
  },
  sent: { label: "Sent", icon: "i-bp-checked", textClassName: "text-colorBlue", bgClassName: "bg-colorBlueLight" },
  failed: { label: "Failed", icon: "i-bp-failed", textClassName: "text-purple-600", bgClassName: "bg-purple-50" },
  unknown: {
    label: "Unknown",
    icon: "i-bp-exclamation",
    textClassName: "text-colorOrange",
    bgClassName: "bg-colorOrangeLight",
  },
};

export const messageKindDisplay = {
  customer: { label: "Customer message" },
  reply: { label: "Staff reply" },
  note: { label: "Internal note" },
} as const;
